var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocalActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 15.5C23 14.74 23.43 14.08 24.06 13.74C24.66 13.41 25 12.73 25 12.04V9.5C25 8.4 24.1 7.5 23 7.5H7C5.9 7.5 5.01 8.39 5.01 9.49V12.04C5.01 12.73 5.34 13.41 5.95 13.73C6.58 14.08 7 14.74 7 15.5C7 16.26 6.57 16.93 5.94 17.26C5.34 17.59 5 18.27 5 18.96V21.5C5 22.6 5.9 23.5 7 23.5H23C24.1 23.5 25 22.6 25 21.5V18.96C25 18.27 24.66 17.59 24.06 17.26C23.43 16.92 23 16.26 23 15.5ZM17.5 19.6L15 18L12.5 19.61C12.12 19.85 11.63 19.5 11.75 19.06L12.5 16.18L10.2 14.3C9.85 14.01 10.03 13.44 10.49 13.41L13.45 13.24L14.53 10.49C14.7 10.07 15.3 10.07 15.46 10.49L16.54 13.25L19.5 13.42C19.95 13.45 20.14 14.02 19.79 14.31L17.49 16.19L18.25 19.05C18.37 19.5 17.88 19.85 17.5 19.6Z",
    fill: "#8C99B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalActivity);
export default __webpack_public_path__ + "static/media/local_activity.e773b717f353aa95323f23d966643621.svg";
export { ForwardRef as ReactComponent };